function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import Polls from './polls';
import URI from 'urijs';
import Group from './group';
import _ from 'underscore';
import Backbone from '@polleverywhere/backbone';
import { format } from 'date-fns';
import $ from 'jquery';
import { deepDefaults } from '../util'; // @namespace Model

var Report = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Report, _Base);

  function Report() {
    return _Base.apply(this, arguments) || this;
  }

  Report.types = function types() {
    return ['summary', 'survey', 'response_pivot', 'participant', 'gradebook'];
  };

  var _proto = Report.prototype;

  _proto.initialize = function initialize() {
    this.polls = new Polls();
    this.competitions = new Backbone.Collection();
    this.surveys = new Backbone.Collection();
  };

  _proto.toJSON = function toJSON() {
    var obj = this.pick(this.modelProperties); // this is a special case where we send IDs instead of keys, because it's
    // much more efficient on the backend to look up activities with id
    // (for the actual activities, not their instances)

    obj.polls = this.polls.pluck('id');
    obj.competitions = this.competitions.pluck('id');
    obj.surveys = this.surveys.pluck('id');
    return obj;
  }
  /*
   * Determines if all polls in a report belong to the same group. If so, it uses
   * `groups` to translate the `group_id` to a `name`. Only used when creating a
   * new report.
   */
  ;

  _proto.defaultName = function defaultName(groups) {
    var group;

    var uniqueGroupIds = _.unique(this.polls.map(function (poll) {
      return poll.get('group_id');
    }));

    var groupId = uniqueGroupIds[0];
    var isDefaultId = groupId === Group.defaultId;

    if (this.polls.length === 1) {
      return this.polls.at(0).cleanTitle({
        emoji: 'strip'
      });
    } else if (uniqueGroupIds.length === 1 && !isDefaultId && (group = groups.get(groupId))) {
      return group.get('name');
    } else {
      return 'Untitled';
    }
  };

  _proto.typeName = function typeName() {
    switch (this.type()) {
      case 'summary':
        return 'Executive summary';

      case 'survey':
        return 'Responses by participant';

      case 'response_pivot':
        return 'Response pivot table';

      case 'participant':
        return 'Participant response history';

      case 'gradebook':
        return 'Gradebook';
    }
  };

  _proto.description = function description() {
    switch (this.type()) {
      case 'summary':
        return 'Visual big-picture overview. Shows engagement, total responses, and participants with a screenshot of each activity. Useful for determining ROI.';

      case 'survey':
        return 'One section per participant, one line per question. If a group of questions was used as a survey, use this report to view each participant’s responses in order.';

      case 'response_pivot':
        return 'Full detail table with one row per response, perfect for exporting to Excel pivot tables. Useful for grouping, crosstabs, or computing sums and averages.';

      case 'participant':
        return 'One section per participant, one line per response. Shows when and how each individual response was submitted.';

      case 'gradebook':
        return 'Compact table with participants listed down the left and questions across the columns. Shows scores, participation, and attendance. Sort by rank to use as a leaderboard.';
    }
  };

  _proto.createdAt = function createdAt() {
    return format(new Date(this.get('created_at')), 'MM/dd/yyyy h:mm:ssa');
  };

  _proto.startedAt = function startedAt() {
    return format(new Date(this.get('started_at')), 'MM/dd/yyyy h:mm:ssa');
  };

  _proto.finishedAt = function finishedAt() {
    return format(new Date(this.get('finished_at')), 'MM/dd/yyyy h:mm:ssa');
  }
  /*
   * This is a temporary route inefficiently proxied through the rails app.
   * This will get replaced with an nginx proxy
   */
  ;

  _proto.resultsUrl = function resultsUrl() {
    return this.url() + '/results';
  };

  _proto.fetchResults = function fetchResults(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    var url = $.support.cors ? this.get('results_url') : this.resultsUrl(); // Default cache: true so that jQuery doesn't
    // append a cachebuster to the URL. Amazon
    // is very picky and will fail the request if the url
    // is modified in any way.

    _.defaults(options, {
      url: url,
      cache: true
    });

    return Backbone.ajax(options).done(function (data) {
      // populate the polls
      _this.polls.set(data.polls, {
        parse: true,
        merge: true
      });
      /*
       * unset results so set ALWAYS triggers a change event
       * even when the results data has not changed on a rerun
       */


      _this.unset('results', {
        silent: true
      }); // set the results attribute


      return _this.set('results', data);
    });
  }
  /**
   * @param {Object} options
   * @param {Boolean} options.results Include results_url in the json
   */
  ;

  _proto.fetch = function fetch(options) {
    if (options === void 0) {
      options = {};
    }

    if (this.isNew()) {
      return $.Deferred().reject();
    }

    if (options.results) {
      deepDefaults(options, {
        data: {
          include: 'results_url'
        }
      });
      return _Base.prototype.fetch.call(this, options);
    } else {
      return _Base.prototype.fetch.apply(this, arguments);
    }
  } // save({}, rerun: true) => reruns the report
  ;

  _proto.save = function save(attributes, opts) {
    if (opts == null) {
      opts = {};
    }

    if (opts.rerun) {
      opts.url = URI(this.url()).addQuery({
        rerun: true
      }).toString();
    }

    return _Base.prototype.save.call(this, attributes, opts);
  };

  _proto.rerun = function rerun() {
    return this.save({}, {
      rerun: true
    });
  };

  _proto.state = function state() {
    return this.get('state');
  };

  _proto.type = function type() {
    return this.get('report_type');
  };

  _proto.options = function options() {
    return this.get('options');
  };

  _proto.filters = function filters() {
    return this.get('filters');
  };

  _proto.results = function results() {
    return this.get('results');
  };

  _proto.isRunning = function isRunning() {
    var needle = this.state();
    return ['queued', 'started'].includes(needle);
  };

  _proto.hasFinished = function hasFinished() {
    var needle = this.state();
    return ['finished', 'failed'].includes(needle);
  } // Poll for changes and return a deferrable
  ;

  _proto.pollForUpdates = function pollForUpdates() {
    var _this2 = this;

    var deferred = $.Deferred();

    var check = function check() {
      return _this2.fetch({
        cache: false,
        results: true
      }).done(function () {
        switch (_this2.state()) {
          case 'finished':
            _this2.checkInterval = null;
            return deferred.resolve();

          case 'failed':
            _this2.checkInterval = null;
            return deferred.reject(_this2.get('error'));

          default:
            _this2.checkInterval = setTimeout(check, 3000);
        }
      }).fail(function () {
        return deferred.reject.apply(deferred, arguments);
      });
    };

    setTimeout(check, 1000);
    return deferred.promise();
  };

  _proto.setOptions = function setOptions(opts) {
    if (opts == null) {
      opts = {};
    }

    return this.setHash('options', opts);
  };

  _proto.saveOptions = function saveOptions(values, opts) {
    if (values == null) {
      values = {};
    }

    if (opts == null) {
      opts = {};
    }

    return this.saveHash('options', values, opts);
  };

  _proto.setFilters = function setFilters(filters, opts) {
    if (filters == null) {
      filters = {};
    }

    if (opts == null) {
      opts = {};
    }

    return this.setHash('filters', filters, opts);
  }
  /*
   * handle opts.wait so that the change events don't get trigger
   * until the ajax request completes
   */
  ;

  _proto.saveFilters = function saveFilters(filters, opts) {
    if (filters == null) {
      filters = {};
    }

    if (opts == null) {
      opts = {};
    }

    return this.saveHash('filters', filters, opts);
  };

  _proto.saveHash = function saveHash(hashName, values, opts) {
    var _this3 = this;

    if (values == null) {
      values = {};
    }

    if (opts == null) {
      opts = {};
    }

    var _this$buildOptionsHas = this.buildOptionsHash(hashName, values, opts),
        hash = _this$buildOptionsHas.hash,
        changeEvents = _this$buildOptionsHas.changeEvents;

    if (!_.isEmpty(changeEvents)) {
      var attrs = {};
      attrs[hashName] = hash;
      var deferred = this.save(attrs, opts);

      if (opts.wait) {
        return deferred.done(function () {
          return _this3.triggerEvents(changeEvents);
        });
      } else if (!opts.silent) {
        return this.triggerEvents(changeEvents);
      }
    }
  };

  _proto.setHash = function setHash(hashName, values, opts) {
    if (values == null) {
      values = {};
    }

    if (opts == null) {
      opts = {};
    }

    var _this$buildOptionsHas2 = this.buildOptionsHash(hashName, values, opts),
        hash = _this$buildOptionsHas2.hash,
        changeEvents = _this$buildOptionsHas2.changeEvents; // no change events means no changes!


    if (!_.isEmpty(changeEvents)) {
      var attrs = {};
      attrs[hashName] = hash;
      this.set(attrs, opts);

      if (!opts.silent) {
        return this.triggerEvents(changeEvents);
      }
    }
  };

  _proto.triggerEvents = function triggerEvents(events) {
    var _this4 = this;

    return _.each(events, function (value, key) {
      return _this4.trigger(key, value);
    });
  };

  _proto.buildOptionsHash = function buildOptionsHash(hashName, newValues) {
    if (newValues == null) {
      newValues = {};
    }

    var values = this.get(hashName);
    var changeEvents = {};
    var hasChanges = false;

    _.each(newValues, function (value, key) {
      if (values[key] !== value) {
        hasChanges = true;
        values[key] = value;
        changeEvents["change:" + hashName + ":" + key] = value;
      }
    });

    if (hasChanges) {
      changeEvents["change:" + hashName] = values;
    }
    /*
     * return the new hash and all the events that will be trigger
     * so the caller can decide when to trigger them
     */


    return {
      hash: values,
      changeEvents: changeEvents
    };
  };

  _createClass(Report, [{
    key: "urlRoot",
    get: function get() {
      return '/api/reports';
    }
  }, {
    key: "modelProperties",
    get: function get() {
      return ['filters', 'options', 'name', 'audience_size', 'report_type'];
    }
  }]);

  return Report;
}(Base);

export { Report as default };